module.exports = __webpack_public_path__ + "img/872-9f4413.png";